import { Inject } from '@angular/core';

export const APP_CONFIG = new Inject('CONFIGURATION');
